import { Box, Stack } from "@chakra-ui/react";
import { SingleCta } from "src/components/common/cta/cta";
import { Bestseller } from "src/components/modules/bestseller-module/bestseller";
import { IBestsellerData } from "src/components/modules/bestseller-module/bestseller.types";
import { Container } from "src/components-mui/layout/container";
import { ITitleAndDescription } from "src/types/common";
import { ICta } from "src/types/cta";
import { ModulePrimaryHeadline, ModuleSecondaryHeadline } from "../../common/module-headlines";
import { SimpleRichText } from "../../common/rich-text/simple-rich-text";

export interface ISingleBestsellerProps extends ITitleAndDescription {
    secondaryTitle?: string;
    secondaryTitleAsH2?: boolean;
    cta: ICta;
    wikifolio: IBestsellerData | null;
}

export const SingleBestSellerModule = ({ title, secondaryTitle, secondaryTitleAsH2, description, cta, wikifolio }: ISingleBestsellerProps) =>
    wikifolio ? (
        <Container>
            <ModulePrimaryHeadline mb={[3, 3, 5]}>{title}</ModulePrimaryHeadline>
            <Stack direction={["column", "row"]} spacing={[3, 4, 5, 13]} justifyContent="space-between">
                <Box>
                    {secondaryTitle && <ModuleSecondaryHeadline titleAsH2={secondaryTitleAsH2 ?? false}>{secondaryTitle}</ModuleSecondaryHeadline>}
                    <SimpleRichText mt={3} fontSize={["md", "md", "lg", "lg"]} text={description} />
                    <Box mt="3" w={["100%", "auto"]}>
                        {cta && <SingleCta {...cta} />}
                    </Box>
                </Box>
                <Box alignSelf={["center", "baseline"]} display="flex" rounded="8px">
                    <Bestseller
                        buttonsDirection={["column", "column", "column", "row-reverse"]}
                        data={wikifolio}
                        w={["312px", "297px", "297px", "358px"]}
                    />
                </Box>
            </Stack>
        </Container>
    ) : null;
